import React, { useContext } from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'
import Products from '../../components/Products/Products'
import PageTitle from '../../ui/PageTitle/PageTitle'
import Settings from '../../components/Settings/Settings'
import Orders from '../../components/Orders/Orders'
import Customers from '../../components/Customers/Customers'
import Marketing from '../../components/Marketing/Marketing'
import Blog from '../../components/Blog/Blog'
import { AuthContext } from '../../App'
import { isMarketingOnlyUser } from '../../config/accessControl'
import { canAccessBlog } from '../../config/blogAccessControl'

function Routes() {
  const { user } = useContext(AuthContext)
  const marketingOnly = isMarketingOnlyUser(user?.uid)
  const showBlog = canAccessBlog(user)

  if (marketingOnly) {
    return (
      <div className="Routes">
        <PageTitle />
        <Switch>
          <Route path="/marketing" component={Marketing} />
          <Redirect to="/marketing/promos" />
        </Switch>
      </div>
    )
  }

  return (
    <div className="Routes">
      <PageTitle />
      <Route path="/products" component={Products} />
      <Route path="/orders" component={Orders} />
      <Route path="/customers" component={Customers} />
      <Route path="/marketing" component={Marketing} />
      {showBlog ? (
        <>
          <Route
            path="/ame-edit"
            render={({ location }) => (
              <Redirect to={{ ...location, pathname: location.pathname.replace(/^\/ame-edit(?=\/|$)/, '/blog') }} />
            )}
          />
          <Route path="/blog" component={Blog} />
        </>
      ) : null}
      <Route path="/settings" component={Settings} />
    </div>
  )
}

export default Routes
